import { ReactNode, createContext, useContext } from 'react';

import { useLocalStorage } from 'support/react/hooks';

export type ArcadeDifficulty = 'easy' | 'normal' | 'hard';

export interface ArcadeContext {
  lives: number;
  score: number;
  playerID: string | null;
  difficulty: ArcadeDifficulty;
  setLives(lives: number): void;
  setScore(score: number): void;
  setPlayerID(playerID: string | null): void;
  setDifficulty(difficulty: ArcadeDifficulty): void;
}

const Context = createContext<ArcadeContext>({} as ArcadeContext);

export interface ArcadeProviderProps {
  children?: ReactNode;
}

export const ArcadeProvider = ({ children }: ArcadeProviderProps) => {
  const [lives, setLives] = useLocalStorage<number>('arcadeLives', { initialValue: 0 });
  const [score, setScore] = useLocalStorage<number>('arcadeScore', { initialValue: 0 });
  const [playerID, setPlayerID] = useLocalStorage<string | null>('arcadePlayerID', { initialValue: null });
  const [difficulty, setDifficulty] = useLocalStorage<ArcadeDifficulty>('arcadeDifficulty', { initialValue: 'normal' });

  return (
    <Context.Provider value={{ lives, score, playerID, difficulty, setLives, setScore, setPlayerID, setDifficulty }}>
      {children}
    </Context.Provider>
  );
};

export function useArcadeContext() {
  return useContext(Context);
}
